export namespace OnboardingStoreActions {

  export class HasVendorPartner {
    static readonly type = '[App] HasVendorPartner';
    constructor(public state: boolean) { }
  }

}
